import React from 'react';

const Badge = ({ children, isActive = false }) => {
    return(
        <span className={`badge ${isActive ? 'active' : ''}`}>{children}</span>
    )
}

export default Badge;